import React, { useState, useEffect, useCallback } from 'react';
import Script from 'react-load-script';

import * as Constants from "./../../helpers/constants"

const FreshChatComp = (props) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [user, setUser] = useState(null)


  useEffect(() => {

    if (FRESHCHAT && user !== props.userDetails) {
      setUser(props.userDetails)
      initializeFreshChat(props.userDetails);
    }
  }, [user, props.userDetails, initializeFreshChat]);


  useEffect(() => {

    if (props.userDetails.isLoginSuccess) {
      if (window.fcWidget) {
        setTimeout(() => {
          window.fcWidget && window.fcWidget.init({
            token: FRESHCHAT_TOKEN,
            widgetUuid: FRESHCHAT_WIDGET_ID,
            host: 'https://wchat.freshchat.com',
            locale: "en",
            restoreId: props.userDetails.restoreId ? props.userDetails.restoreId.restore_id : null,
            config: Constants.FRESHCHAT_CONFIG
          })
          window.fcWidget.setExternalId(props.userDetails.id ? props.userDetails.id : null);
          window.fcWidget.user.setFirstName(props.userDetails.name ? props.userDetails.name : null);
          window.fcWidget.user.setLastName(' ');
          window.fcWidget.user.setEmail(props.userDetails.email ? props.userDetails.email : null)
        }, 500);
      }
    }
  }, [props.userDetails.isLoginSuccess, props.userDetails.id, props.userDetails.email, props.userDetails.name, props.userDetails.restoreId, initializeFreshChat]);

  const initializeFreshChat = useCallback(() => {

    let userDetails = user
    if (FRESHCHAT && userDetails) {
      const widgetConfig = {
        locale: "en",
        config: Constants.FRESHCHAT_CONFIG
      };

      if (userDetails.isLoginSuccess) {
        widgetConfig.restoreId = userDetails.restoreId || null;
        window.fcSettings = {
          onInit: function () {
            window.fcWidget.setExternalId(userDetails.id || null);
            window.fcWidget.user.setFirstName(userDetails.name || null);
            window.fcWidget.user.setLastName(' ');
            window.fcWidget.user.setEmail(userDetails.email || null);

            if (!userDetails.restoreId) {
              window.fcWidget.on('user:created', (resp) => {
                if (resp.success && resp.data && resp.data.restoreId) {
                  props.setFcRestoreId(resp.data.restoreId);
                }
              });
            }
          }
        };
      }

      window.fcWidgetMessengerConfig = widgetConfig;
    }
  }, [props, user]);


  const handleScriptCreate = useCallback(() => {
    setScriptLoaded(false);
  }, []);

  const handleScriptError = useCallback(() => {
    console.error('Script loading error');
  }, []);

  const handleScriptLoad = useCallback(() => {
    initializeFreshChat();
    setScriptLoaded(true);
  }, [initializeFreshChat]);

  return (
    FRESHCHAT && user && !scriptLoaded ? (
      <Script
        key={props.id}
        url="//fw-cdn.com/11508754/4168848.js"
        attributes={{ "chat": "true", "widgetId": FRESHCHAT_WIDGET_ID }}
        onCreate={handleScriptCreate}
        onError={handleScriptError}
        onLoad={handleScriptLoad}
      />
    ) : null
  );
};

export default FreshChatComp;
